import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageWrapper } from '@/components/PageWrapper';
import { refreshUserFirestoreEntitlement } from '@/utils/userFirestoreEntitlement';
import { getCurrentFirebaseUid } from '@/utils/firebase';

/** PayPal `return_url` lands here; entitlement is updated asynchronously via webhook. */
export function PaypalReturn() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const uid = getCurrentFirebaseUid();
        if (uid) await refreshUserFirestoreEntitlement(uid);
      } catch {
        /* ignore */
      }
      if (!cancelled) navigate('/settings', { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <PageWrapper className="bg-app">
      <div className="max-w-md mx-auto w-full min-w-0 px-6 py-16 text-center">
        <p className="font-body text-primary">Finishing up with PayPal…</p>
        <p className="font-body text-sm text-secondary mt-2">Taking you back to Settings.</p>
      </div>
    </PageWrapper>
  );
}
